import { backend_api_v2 } from '/src/utils/apiv2'
import { useSelectedStore } from "/src/stores/selected"
import { useSessionStore } from "/src/stores/session"


function send_backend_event(ev) {
    const selected_store = useSelectedStore()
    let pr = selected_store.selected_project
    if (pr && pr.uuid && pr.uuid != "all") ev.project = pr.uuid

    let mod = selected_store.selected_mod
    if (mod && mod.uuid) ev.module = mod.uuid

    let ass = selected_store.selected_ass
    if (ass && ass.uuid) ev.assembly = ass.uuid

    return backend_api_v2.post('/records/events/', ev)
        .then(({ data }) => {
            console.log("[i] Posted V2 ProductionEvent:", data.event)
        })
        .catch(() => {
            // Don't retry if user is logged out
            if (!useSessionStore().authenticated) {
                console.log("[!] Can't post event:", ev.event, "-> Dropped (logged out)")
                return
            }
            console.log("[!] Can't post event:", ev.event, "-> Retrying in 10 seconds...")
            setTimeout(() => send_backend_event(ev), 10000)
        })
}

export default send_backend_event
